import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { RefreshCw } from 'lucide-react';

export default function VendorLedgerFilters({
  vendors, vendorId, setVendorId, startDate, setStartDate, endDate, setEndDate,
  includeCancelled, setIncludeCancelled, onApply, loading,
}) {
  return (
    <div className="flex flex-wrap items-end gap-3 p-4 rounded-xl border border-slate-200 bg-white">
      <div>
        <Label className="text-xs text-slate-500">Vendor</Label>
        <select
          value={vendorId}
          onChange={(e) => setVendorId(e.target.value)}
          className="h-9 rounded-md border border-slate-200 px-2 text-sm bg-white mt-1"
          data-testid="ledger-vendor-select"
        >
          <option value="">All vendors</option>
          {vendors.map((v) => <option key={v.vendorId} value={v.vendorId}>{v.name}</option>)}
        </select>
      </div>
      <div>
        <Label className="text-xs text-slate-500">From</Label>
        <Input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="h-9 mt-1" data-testid="ledger-start-date" />
      </div>
      <div>
        <Label className="text-xs text-slate-500">To</Label>
        <Input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="h-9 mt-1" data-testid="ledger-end-date" />
      </div>
      <label className="flex items-center gap-1.5 text-sm text-slate-600 mb-1.5 cursor-pointer">
        <input type="checkbox" checked={includeCancelled} onChange={(e) => setIncludeCancelled(e.target.checked)} data-testid="ledger-include-cancelled" />
        Include cancelled (audit)
      </label>
      <Button size="sm" onClick={onApply} disabled={loading} data-testid="ledger-apply-filters-btn" className="bg-teal-700 hover:bg-teal-800 text-white">
        <RefreshCw className={loading ? 'h-3.5 w-3.5 mr-1.5 animate-spin' : 'h-3.5 w-3.5 mr-1.5'} />
        Apply
      </Button>
    </div>
  );
}
